import { defineStore } from 'pinia'

interface Dialog {
  type: 'alert' | 'confirm' | 'none';
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  buttonDir: 'row' | 'col';
  _resolver?: (result: boolean) => void;
}

const initialState: Dialog = {
  type: 'none',
  title: '',
  description: '',
  confirmLabel: '',
  cancelLabel: '',
  buttonDir: 'col',
  _resolver: undefined
}

export const useDialogStore = defineStore('dialog', {
  state: () => ({ ...initialState }),
  actions: {
    setDialog (dialog: Dialog) {
      Object.assign(this, dialog)
    },
    resolve (result: boolean) {
      if (this._resolver) {
        this._resolver(result)
      }

      this.$reset()
    },
    reset () {
      this.type = 'none'
      setTimeout(() => {
        this.$reset()
      }, (1000))
    }
  }
})
